import { BrokerStatus, PAGES } from "@dune/types";
import { getBrokerDetails } from "../api/queries/users.queries";

export const RESTRICTED_STATUSES: BrokerStatus[] = [
	"NEW",
	"TO_ANALYZE",
	"TO_SIGN",
];

export const checkBrokerAccess = async () => {
	try {
		const brokerData = await getBrokerDetails();
		const brokerStatus = brokerData.brokerDetails?.status;

		const isAccessRestricted = brokerStatus
			? RESTRICTED_STATUSES.includes(brokerStatus)
			: true;

		if (isAccessRestricted) {
			return {
				canAccessApp: false,
				redirectTo: PAGES.REGISTER_BROKER_SECOND_STEP.index,
				brokerStatus,
			};
		}

		return {
			canAccessApp: true,
			redirectTo: PAGES.ROOT,
			brokerStatus,
		};
	} catch {
		return {
			canAccessApp: false,
			redirectTo: PAGES.REGISTER_BROKER_SECOND_STEP.index,
			brokerStatus: null,
		};
	}
};
